export default "__VITE_ASSET__Bew8X35X__"